exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".order-one{-ms-flex-order:1!important;order:1!important}.no-payment,.non-bold{font-weight:400}.no-payment{color:#86b0f5}.no-text-decoration{text-decoration:none}.commission-card{margin-bottom:15px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-card/vendor-rsvp-card.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB,sBAGC,eAAmB,CAGrB,YAEE,aAAc,CACf,oBAGC,oBAAsB,CACvB,iBAGG,kBAAoB,CACvB","file":"vendor-rsvp-card.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.no-payment {\n  font-weight:normal;\n  color: #86B0F5\n}\n\n.no-text-decoration {\n  text-decoration: none;\n}\n\n.commission-card{\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-card/vendor-rsvp-card.component.css
// module id = scbP
// module chunks = 0